import { render, staticRenderFns } from "./OAuth2LoginEasyWork.vue?vue&type=template&id=22b1eecc&scoped=true&"
import script from "./OAuth2LoginEasyWork.vue?vue&type=script&lang=js&"
export * from "./OAuth2LoginEasyWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b1eecc",
  null
  
)

export default component.exports